import React from 'react';
import CardHeader from './cardHeader';
import HeaderCard from './headerCard';
import PlainCard from './plainCard';
import Quote from './quote';

const RandomCard = ({ randomType, ...props }) => {
  switch (randomType) {
    case 0:
      return <CardHeader {...props} />;
    case 1:
      return <HeaderCard {...props} />;
    case 2:
      return <PlainCard {...props} />;
    default:
      return <Quote {...props} />;
  }
};

export default RandomCard;
